module.exports = __webpack_public_path__ + "img/logo.ef12e2a4.png";